import * as React from 'react';

const DataSersIcon = () => {

	return (<svg version="1.1" x="0px" y="0px" width="16px" height="16px" viewBox="0 0 16 16">
		<g>
			<path fill="currentColor" d="M7.1,13C6.87,13,6.67,13,6.54,13c-0.93,0-4.64-0.06-6.43-0.96c-0.06,0.08-0.1,0.16-0.1,0.24v2.17
		c0,0.8,2.92,1.44,6.53,1.44c0.76,0,1.48-0.03,2.15-0.08C7.88,15.12,7.3,14.16,7.1,13z"></path>
			<path fill="currentColor" d="M6.54,5.06c3.61,0,6.53-0.65,6.53-1.44V1.44c0-0.8-2.92-1.44-6.53-1.44S0.01,0.65,0.01,1.44v2.17
		C0.01,4.41,2.94,5.06,6.54,5.06z M6.54,0.62c1.55,0,2.81,0.21,2.81,0.47c0,0.26-1.26,0.47-2.81,0.47c-1.55,0-2.81-0.21-2.81-0.47
		C3.73,0.83,4.99,0.62,6.54,0.62z"></path>
			<path fill="currentColor" d="M6.54,8.67c0.6,0,1.18-0.02,1.73-0.05c0.9-1,2.21-1.63,3.73-1.63c0.37,0,0.72,0.05,1.07,0.12V5.06
		c0-0.08-0.04-0.16-0.1-0.24c-1.79,0.9-5.5,0.96-6.43,0.96S1.9,5.72,0.12,4.82c-0.06,0.08-0.1,0.16-0.1,0.24v2.17
		C0.01,8.02,2.94,8.67,6.54,8.67z"></path>
			<path fill="currentColor" d="M6.54,12.28c0.17,0,0.33,0,0.49-0.01c-0.01-0.1-0.03-0.2-0.03-0.3c0-0.98,0.27-1.86,0.71-2.61
		C7.2,9.39,6.78,9.39,6.54,9.39c-0.93,0-4.64-0.06-6.43-0.96c-0.06,0.08-0.1,0.16-0.1,0.24v2.17C0.01,11.64,2.94,12.28,6.54,12.28z"></path>
			<path fill="currentColor" d="M12.85,15.85c2.16-0.47,3.56-2.42,3.06-4.75c-0.54-2.5-2.6-3.52-4.75-3.06C9,8.51,7.63,10.64,8.1,12.79
		C8.57,14.95,10.69,16.32,12.85,15.85z M12.66,9.71v1.78h1.49v2.97h-3.57V9.71H12.66 M12.9,11.27V9.71l1.25,1.56H12.9z"></path>
		</g>
	</svg>)
};

export default DataSersIcon